import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { IFieldConfig } from "@shared/lib/types/briefInfluencerV2";
import { BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY } from "../constants";
import { BriefService } from "../services/brief.service";
import { setBriefByIdQueryData } from "./useGetBriefById";

interface IToggleBriefDataFieldV2Request {
  briefId: string;
  brandId: string;
  dataFieldsV2?: IFieldConfig[];
  visibleBrandCustomFieldsV2?: IFieldConfig[];
  visibleBrandPerformanceFieldsV2?: IFieldConfig[];
  visibleBriefTableColumns?: string[];
}

export function useToggleBriefDataFieldV2(briefId: string) {
  const {
    mutate: toggleDataField,
    isLoading: isToggling,
    isSuccess: isToggled,
    variables,
  } = useMutation({
    mutationFn: (data: IToggleBriefDataFieldV2Request) =>
      BriefService.toggleBriefDataFieldV2(
        data.briefId,
        data.brandId,
        data.visibleBrandCustomFieldsV2,
        data.visibleBrandPerformanceFieldsV2,
        data.dataFieldsV2,
        data.visibleBriefTableColumns
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {
      skipInvalidation: true,
    },
    onSuccess: (c, response) => {
      setBriefByIdQueryData(c, briefId, response);
      setTimeout(() => {
        c.invalidateQueries({
          queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY, briefId],
        });
      }, 3000);
    },
  });

  return {
    toggleDataField,
    isToggling,
    isToggled,
    variables,
  };
}
